__turbopack_context__.v({
  "listingsSeoLinks": "listings-seo-links-module-scss-module__epGjhW__listingsSeoLinks",
  "listingsSeoLinks_areaTitle": "listings-seo-links-module-scss-module__epGjhW__listingsSeoLinks_areaTitle",
  "listingsSeoLinks_container": "listings-seo-links-module-scss-module__epGjhW__listingsSeoLinks_container",
  "listingsSeoLinks_item": "listings-seo-links-module-scss-module__epGjhW__listingsSeoLinks_item",
  "listingsSeoLinks_list": "listings-seo-links-module-scss-module__epGjhW__listingsSeoLinks_list",
  "listingsSeoLinks_title": "listings-seo-links-module-scss-module__epGjhW__listingsSeoLinks_title",
  "listingsSeoLinks_wrapper": "listings-seo-links-module-scss-module__epGjhW__listingsSeoLinks_wrapper",
});
